/**
 * RunStatusBadge — terminal run status chip.
 *
 * Evals V2 runs arrive terminal from external pipelines, so the only
 * states are completed and failed.
 */

import { Badge } from '@/components/ui/badge'
import { EvalRunSummaryStatus } from '@/api/generated/model'

interface RunStatusBadgeProps {
  status: EvalRunSummaryStatus
}

export function RunStatusBadge({ status }: RunStatusBadgeProps): React.JSX.Element {
  switch (status) {
    case EvalRunSummaryStatus.completed:
      return <Badge variant="success">Completed</Badge>
    case EvalRunSummaryStatus.failed:
      return <Badge variant="destructive">Failed</Badge>
  }
}
